import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';

export const ContactSummary = ({ userCount, emailCount, smsCount }) => {
  const { t } = useTranslation('broadcasts');

  return (
    <Container>
      <Summary>
        <UniqueContacts>
          <Text variant="button">{t('audience.totalUniqueContacts')}</Text>
          <Text variant="subtitle1">{userCount}</Text>
        </UniqueContacts>

        <ContactBreakdown>
          <Text variant="button">{t('audience.contactBreakdown')}</Text>
          <Text variant="subtitle1">
            {t('audience.emailCount', { count: emailCount })}
          </Text>
          <Text variant="subtitle1">
            {t('audience.smsCount', { count: smsCount })}
          </Text>
        </ContactBreakdown>
      </Summary>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const UniqueContacts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

const ContactBreakdown = styled(UniqueContacts)``;

const Summary = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: ${themeGet('colors.black.5')};
`;
